import { inject, Injectable } from '@angular/core';
import {
  ProfileInfoDto,
  SignInPayload,
  SignInResponse,
  SignUpPayload,
} from '../../shared/models/UserModels';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class IdentityService {
  private httpClient = inject(HttpClient);

  getMe() {
    return this.httpClient.get<ProfileInfoDto>(environment.baseUrl + environment.me);
  }

  signUp(model: SignUpPayload) {
    return this.httpClient.post(environment.baseUrl + environment.signUp, model, {
      headers: this.getJsonHeaders(),
    });
  }

  signIn(model: SignInPayload) {
    return this.httpClient.post<SignInResponse>(
      environment.baseUrl + environment.signIn,
      this.buildSignInBody(model),
      { headers: this.getFormUrlEncodedHeaders() },
    );
  }

  refreshTokenSignIn(refreshToken: string) {
    const params = new HttpParams()
      .set('grant_type', 'refresh_token')
      .set('refresh_token', refreshToken);

    return this.httpClient.post<SignInResponse>(environment.baseUrl + environment.signIn, params, {
      headers: this.getFormUrlEncodedHeaders(),
    });
  }

  private getJsonHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
    });
  }

  private buildSignInBody(model: SignInPayload): string {
    return new HttpParams()
      .set('grant_type', 'password')
      .set('username', model.email)
      .set('password', model.password)
      .toString();
  }

  private getFormUrlEncodedHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });
  }

  public resendConfirmationEmail(email: string) {
    return this.httpClient.post(
      environment.baseUrl + environment.resendEmail,
      { email: email },
      { headers: this.getJsonHeaders() },
    );
  }
}
